import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { feedbackStyles } from '../../../Styles/feedbackStyles';
import { inject, observer } from 'mobx-react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';

@inject('feedbackStore')
@observer
class CloseChatWarning extends Component {

    render() {
        const { classes } = this.props;
        return (
            <Dialog classes={{ paper: classes.dialog }} open={this.props.open} onClose={this.props.closeDialog}>
                <DialogContent classes={{root: classes.dialogContent}}>
                    <div className={classes.heading}>Are you sure you want to go back?</div>
                    <div className={classes.subHeading}>Going back will cause your ongoing chat to close?</div>
                    <div className="rowFlex" style={{justifyContent: 'center'}}>
                        <Button variant="contained" onClick={(e)=> this.props.confirmCloseChat()} className={classes.button} type="submit" fullWidth>Yes</Button>
                        <Button variant="contained" onClick={(e)=> this.props.closeDialog()}  className={classes.cancelButton} fullWidth>No</Button>
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}
CloseChatWarning.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(withStyles(feedbackStyles)(CloseChatWarning));
